export default __webpack_public_path__ + "static/moon_bunnies_c-44cb028d97cdde28f1ff67923699bcb4.jpg";